import styled, { css } from "styled-components";
import Spring from "../../components/Spring";
import { IPageNumbersStyleProps } from "./interfaces";

export const StyledBrowse = styled(Spring)`
    overflow: hidden;
    background-color: ${p => p.theme.c.snow};
    min-height: calc(100vh - 50px);
`;

export const BrowseContent = styled.div`
    display: grid;
    grid-template-columns: 300px auto;
    grid-column-gap: 24px;
    ${p =>
        p.theme.sm.max(css`
            grid-template-columns: auto;
        `)}
`;

export const StyledFilters = styled.div`
    h3 {
        cursor: pointer;
        overflow: hidden;
        margin: 12px 0;
    }
`;

export const PageNumbers = styled.div<IPageNumbersStyleProps>`
    text-align: right;
    margin-bottom: ${p => (p.down ? 24 : 0)}px;
    flex: 1;
`;

export const PageNumber = styled.button`
    font-size: 19px;
    background-color: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    font-weight: 300;
    color: ${p => p.theme.c.grey7};
    padding: 0 10px;

    &.Active {
        font-weight: 600;
        color: ${p => p.theme.c.active};
        pointer-events: none;
    }

    &:disabled {
        color: ${p => p.theme.c.disabled};
        cursor: default;
    }
`;

export const Holder = styled.div`
    display: grid;
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    margin-bottom: 16px;
    ${p =>
        p.theme.md.only(css`
            grid-template-columns: 1fr 1fr;
        `)}

    ${p =>
        p.theme.lg(css`
            grid-template-columns: 1fr 1fr 1fr;
        `)}
    ${p =>
        p.theme.sm.max(css`
            grid-template-columns: 1fr 1fr;
        `)}
    @media (max-width: 600px) {
        grid-template-columns: 1fr;
    }
`;

export const QueryBar = styled.div`
    margin-top: 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
        width: calc(33% - 10px);
        ${p =>
            p.theme.md.only(css`
                width: calc(50% - 10px);
            `)}
        ${p =>
            p.theme.sm.max(css`
                width: 100%;
            `)}
    }
    .button {
        height: 43px;
        margin-top: 8px;
        margin-right: 8px;
    }
`;

export const Hr = styled.hr`
    height: 1.1px;
    border: none;
    background-color: ${p => p.theme.c.greyD};
    margin-top: 0;
    margin-bottom: 16px;
`;

export const DeleteQuery = styled.button`
    background-color: transparent;
    border: none;
    font-size: 16px;
    color: ${p => p.theme.c.grey5};
    cursor: pointer;
    outline: 0;
    font-weight: 300;
    ${p =>
        p.theme.xs(css`
            margin-top: 8px;
        `)}
`;

export const NoResult = styled.h4`
    text-align: center;
    margin-top: 30vh;
    ${p =>
        p.theme.xs(css`
            margin-top: 32px;
        `)}
`;

export const TotalDocs = styled.div`
    color: ${p => p.theme.c.greyA};
    margin: -4px 0 6px;
    display: flex;
`;

export const DesktopFilters = styled.div`
    display: flex;
    flex-direction: column;
    ${p =>
        p.theme.sm.max(css`
            display: none;
        `)}
`;

export const FilterButton = styled.button`
    ${p =>
        p.theme.md.min(css`
            display: none;
        `)}
`;

export const SortContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
`;

export const SortContainerMobile = styled.div`
    display: flex;
    justify-content: flex-start;
    margin-top: 8px;
`;

export const SortLabel = styled.div`
    line-height: 42px;
    margin-right: 8px;
    color: ${p => p.theme.c.greyA};
    font-weight: 300;
    white-space: nowrap;
`;

export const SortWrapper = styled.div`
    width: 200px;
`;

export const SortForDesktop = styled.div`
    z-index: 7;
    ${p =>
        p.theme.xs(css`
            display: none;
        `)}
`;
export const SortForMobile = styled.div`
    z-index: 7;
    ${p =>
        p.theme.sm.min(css`
            display: none;
        `)}
`;

export const AboveQueryAdSense = styled.div`
    margin-top: 24px;
    max-width: 100%;
    ${p =>
        p.theme.xs(css`
            display: none;
        `)}
`;

export const FilterBottomAdSense = styled.div`
    flex: 1;
    margin-top: 4px;
`;

export const BottomAdSense = styled.div`
    margin-bottom: 20px;
`;

export const TopMobileAdSense = styled.div`
    display: flex;
    justify-content: center;
    margin: 0 -20px 20px;
    ${p =>
        p.theme.sm.min(css`
            display: none;
        `)}
`;

export const AdWrapper = styled.div`
    @media (max-width: 600px) {
        height: 250px;
        margin: 0 -20px;
    }

    ${p =>
        p.theme.sm.min(css`
            max-height: 250px;
            height: 250px;
            margin-bottom: -10px;
        `)}
`;
